/**
 * Возвращает строку с максимальным количеством символов не больше N,
 * при этом не обрезая слова
 * @param str - начальная строка
 * @param n - максимальное количество символов выходной строки
 */
export const truncateText = (str: string, n: number) =>
    str.split(/\s+/).reduce((acc, value) => {
        if (acc.length + value.length + 1 > n) {
            return acc;
        }

        return `${acc}${acc ? ' ' : ''}${value}`;
    }, '');
